import AuthWAService from './AuthWAService';
import AuthLDAPService from './AuthLDAPService';
import AuthRUService from './AuthRUService';

export default AuthRUService;